var _defs, _circle, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".user_svg__cls-1{fill:#034f52}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "user_svg__cls-1",
    cx: 14.36,
    cy: 8.02,
    r: 5.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "user_svg__cls-1",
    d: "M14.36 14.51c-3.58 0-6.5-2.91-6.5-6.5s2.92-6.49 6.5-6.49 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zm0-11.69c-2.87 0-5.2 2.33-5.2 5.2s2.33 5.2 5.2 5.2 5.2-2.33 5.2-5.2-2.33-5.2-5.2-5.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "user_svg__cls-1",
    d: "M9.17 15.81s-5.85 1.95-5.2 11.69h22.09s.65-8.45-5.2-11.69c0 0-7.15 4.55-11.69 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "user_svg__cls-1",
    d: "M26.96 28.48H3.06L3 27.57c-.69-10.38 5.59-12.59 5.86-12.68l.57-.19.43.43c3.94 3.94 10.42-.09 10.48-.13l.49-.31.51.28c6.32 3.51 5.72 12.25 5.7 12.62l-.07.9zM4.9 26.53h20.2c-.03-2.06-.52-7.15-4.25-9.59-1.78.98-7.57 3.67-11.87.02-1.23.68-4.25 3.02-4.08 9.56z"
  }))));
}

export default __webpack_public_path__ + "8cb4b7be3f4a9ab5e165b2b6a9e7dbee.svg";
export { SvgUser as ReactComponent };